// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2wJv5","title":"Header_title__pLD7m","left":"Header_left__3B9xj","clinicName":"Header_clinicName__2WxOp"};